<template>
  <!-- 结算录入 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        :loading="submitLoading"
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit(0)"
        >保存</el-button
      >
      <!-- v-if="outgoingId"  -->
      <el-button
        :loading="submitLoading"
        style="margin-top: 10px"
        class="glo_bg"
        @click="submit(1)"
        >确认过账</el-button
      >
    </div>
    <div v-if="t==1">
      <el-form inline>
        <el-form-item label="运单号:" required>
          <el-select
            v-model="waybillNumberKeyword"
            filterable
            remote
            :remote-method="remoteSearchWaybillMethod"
            :loading="loading"
            @change="changeWaybillNumberKeyword"
            clearable
          >
            <el-option
              v-for="waybill in waybills"
              :key="waybill.waybillSplitId"
              :label="waybill.waybillNumber"
              :value="waybill.waybillSplitId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size="small" class="glo_bgcMainColor">
            搜索
          </el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <!-- 基本信息 -->
    <div class="infoDiv">
      <div class="h3title">基本信息</div>
      <div class="formbox">
        <el-form label-width="120px" class="glo_formBox">
          <el-form-item label="外发时间:" required>
            <el-date-picker
              v-model="addReqs.outgoingTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="外发网点:" required>
            <!-- dispatchDeptId startDeptId -->
            <el-select
              v-model="addReqs.startDeptId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'storage', 'storageList');
                }
              "
              @focus="
                (e) => {
                  focusMethod('storage', 'storageList');
                }
              "
              @clear="remoteMethod('', 'storage', 'storageList')"
            >
              <!-- @change="
                (e) => {
                  changeMethod(e, 'storageList', 'intoDeptName');
                }
              "-->
              <el-option
                v-for="(item, index) in storageList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="收货方式:" required>
            <el-select
              filterable
              clearable
              v-model="addReqs.outgoingReceiveMethodConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in OUTTakeMethodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货方式:" required>
            <el-select
              filterable
              clearable
              v-model="sendMethodConfDictId"
              placeholder="请输入"
            >
              <el-option
                v-for="item in OUTsendMethodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="承运商属性:" style="min-width: 320px" required>
            <el-radio-group
              v-model="carrierAttributeConfDictKey"
              @change="changeCarrierAttributeConf"
            >
              <el-radio label="zheng_shi">正式</el-radio>
              <el-radio label="lin_shi">临时</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="carrierAttributeConfDictKey == 'zheng_shi'">
            <el-form-item label="外发承运商:" required>
              <el-select
                v-model="addReqs.carrierName"
                placeholder="请选择"
                clearable
                filterable
                remote
                :allow-create="carrierAttributeConfDictKey == 'lin_shi'"
                :default-first-option="carrierAttributeConfDictKey == 'lin_shi'"
                :remote-method="
                  (e) => {
                    remoteMethodCarrier(e);
                  }
                "
                @focus="
                  (e) => {
                    focusMethodCarrier(e);
                  }
                "
                @change="
                  (e) => {
                    changeMethodCarrier(e);
                  }
                "
                @clear="remoteMethodCarrier('')"
              >
                <el-option
                  v-for="(item, index) in changeCarrierList"
                  :key="index"
                  :label="item.carrierName"
                  :value="item.carrierName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承运商网点:" required>
              <el-select
                v-model="addReqs.carrierDeptName"
                placeholder="请选择"
                clearable
                filterable
                remote
                :allow-create="carrierAttributeConfDictKey == 'lin_shi'"
                :default-first-option="carrierAttributeConfDictKey == 'lin_shi'"
                :remote-method="
                  (e) => {
                    remoteMethodCarrier1(e);
                  }
                "
                @focus="
                  (e) => {
                    focusMethodCarrier1(e);
                  }
                "
                @change="
                  (e) => {
                    changeMethodCarrier1(e);
                  }
                "
                @clear="remoteMethodCarrier1('')"
              >
                <el-option
                  v-for="(item, index) in CarrierDeptListList"
                  :key="index"
                  :label="item.deptName"
                  :value="item.deptName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承运商电话:" required>
              <el-input
                v-model="addReqs.carrierPhone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="外发承运商:" required>
              <el-input
                v-model="addReqs.carrierName"
                placeholder="请输入"
                clearable
                filterable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="承运商电话:" required>
              <el-input
                v-model="addReqs.carrierPhone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="承运商联系人:" required>
              <el-input
                v-model="addReqs.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%; border: 0"
              label="承运商地址地址:"
            >
              <div class="disFlexs">
                <el-select
                  class="selectAddress"
                  v-model="addReqs.carrierProvince"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince"
                >
                  <el-option
                    v-for="(item, index) in provinceArr"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  class="selectAddress"
                  v-model="addReqs.carrierCity"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity"
                  @focus="getCityName(addReqs.provinceName)"
                >
                  <el-option
                    v-for="(item, index) in cityArr"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  class="selectAddress"
                  v-model="addReqs.carrierArea"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(addReqs.cityName)"
                >
                  <el-option
                    v-for="(item, index) in districtArr"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  class="selectAddress addressDetails"
                  v-model="addReqs.carrierAddress"
                  placeholder="请输入详细地址"
                  clearable
                ></el-input>
                <!-- <i
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(1)"
                ></i>
                <i
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(1)"
                ></i>
                <i
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(1)"
                ></i> -->
                <div class="checkBox">
                  <el-checkbox v-model="isAddCarrier"
                    >收录承运商信息</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="发货人:" required>
            <el-select
              v-model="addReqs.sendEmployeeId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList');
                }
              "
              @focus="
                (e) => {
                  focusMethod('employee', 'employeeList');
                }
              "
              @clear="remoteMethod('', 'employee', 'employeeList')"
            >
              <el-option
                v-for="(item, index) in employeeList"
                :key="index"
                :label="item.name"
                :value="Number(item.documentId)"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="结算方式:" required>
            <el-select
              filterable
              clearable
              v-model="addReqs.settlementMethodConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in out_going_settlement_method_list"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计费方式:" required>
            <el-select
              filterable
              clearable
              v-model="formulaBillingWeightId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in out_going_billing_method_list"
                :key="item.formulaBillingWeightId"
                :label="item.formulaBillingWeightName"
                :value="Number(item.formulaBillingWeightId)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="承运单号:" required>
            <el-input
              v-model="addReqs.outgoingNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="预计到达时间:" required>
            <el-date-picker
              v-model="addReqs.expectDeliveryTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="总重量">
            <el-input v-model="totalGrossWeightSum" disabled></el-input>
          </el-form-item>
          <el-form-item label="总体积">
            <el-input v-model="totalVolumeSum" disabled></el-input>
          </el-form-item>
          <el-form-item label="承运商称重:">
            <div class="disFlexs jsInput">
              <el-input
                v-model="addReqs.allCarrierWeigh"
                @input="inputTotalAmount"
                placeholder="请输入"
                clearable
                type="number"
              ></el-input>
              <el-button
                v-if="
                  true ||
                  (addReqs.waybillList && addReqs.waybillList.length > 1)
                "
                class="jsBtns glo_bgcMainColor"
                @click="click_allCarrierWeigh"
                >摊分</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="承运商体积:">
            <div class="disFlexs jsInput">
              <el-input
                v-model="addReqs.allCarrierVolume"
                @input="inputTotalAmount"
                placeholder="请输入"
                clearable
                type="number"
              ></el-input>
              <el-button
                v-if="
                  true ||
                  (addReqs.waybillList && addReqs.waybillList.length > 1)
                "
                class="jsBtns glo_bgcMainColor"
                @click="click_allCarrierVolume"
                >摊分</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="运费:">
            <div class="disFlexs jsInput">
              <el-input
                v-model="addReqs.basicFreight"
                @input="inputTotalAmount"
                placeholder="请输入"
                clearable
                type="number"
              ></el-input>
              <el-button
                v-if="
                  true ||
                  (addReqs.waybillList && addReqs.waybillList.length > 1)
                "
                class="jsBtns glo_bgcMainColor"
                @click="clickSharing_basicFreight"
                >摊分</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="送货费:">
            <div class="disFlexs jsInput">
              <el-input
                v-model="addReqs.sendFee"
                @input="inputTotalAmount"
                placeholder="请输入"
                clearable
              ></el-input>
              <el-button
                v-if="
                  true ||
                  (addReqs.waybillList && addReqs.waybillList.length > 1)
                "
                class="jsBtns glo_bgcMainColor"
                @click="clickSharing_sendFee"
                >摊分</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="其他费用:">
            <div class="disFlexs jsInput">
              <el-input v-model="addReqs.allOtherFee" clearable></el-input>
              <el-button
                v-if="
                  true ||
                  (addReqs.waybillList && addReqs.waybillList.length > 1)
                "
                class="jsBtns glo_bgcMainColor"
                @click="clickSharing_otherFee"
                >摊分</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="承运商单价:">
            <el-input v-model="carrierUnitPrice" clearable disabled></el-input>
          </el-form-item>
          <el-form-item label="外发总额:">
            <el-input disabled v-model="totalFreight" clearable></el-input>
          </el-form-item>
          <el-form-item label="" label-width="0" style="border: none">
            <el-checkbox
              v-model="addReqs.isReceivedPayWithCarrier"
              @change="changeIsCarrierSettlement()"
              :true-label="1"
              :false-label="0"
              >到付费用与承运商结算</el-checkbox
            >
          </el-form-item>
          <el-form-item label="代收货款:">
            <el-input disabled v-model="agentAmount" clearable></el-input>
          </el-form-item>
          <el-form-item label="到付运费:">
            <el-input disabled v-model="receivedAmount" clearable></el-input>
          </el-form-item>
          <el-form-item label="到付总额:">
            <el-input disabled v-model="receivedAmountSum" clearable></el-input>
          </el-form-item>
          <el-form-item label="应付余额:">
            <el-input disabled v-model="shouldOutAmount" clearable></el-input>
          </el-form-item>
          <el-form-item label="应收余额:">
            <el-input disabled v-model="shouldInAmount" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="总摊分合计:">
            <el-input
              disabled
              v-model="apportionmentTotal"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="总净重:">
            <el-input
              disabled
              v-model="addReqs.totalNetWeight"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人:"
            required
            v-if="carrierAttributeConfDictKey == 'lin_shi'"
          >
            <el-input
              v-model="addReqscontacts"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="carrierAttributeConfDictKey == 'lin_shi'"
            style="width: 100%; border: 0"
            label="联系地址:"
            required
          >
            <div class="disFlexs">
              <el-select
                class="selectAddress"
                v-model="addReqs.carrierProvince"
                @change="changeProvince"
                placeholder="请选择省"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in provinceArr"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                />
              </el-select>
              <el-select
                class="selectAddress"
                v-model="addReqs.carrierCity"
                @change="changeCity"
                placeholder="请选择市"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in cityArr"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                />
              </el-select>
              <el-select
                class="selectAddress"
                v-model="carrierArea"
                placeholder="请选择区"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in districtArr"
                  :key="index"
                  :label="item.districtName"
                  :value="item.districtName"
                />
              </el-select>
              <el-input
                class="selectAddress addressDetails"
                v-model="addReqs.carrierAddress"
                placeholder="请输入详细地址"
                clearable
              />
              <div class="checkBox">
                <el-checkbox v-model="isAddCarrier">收录承运商信息</el-checkbox>
              </div>
            </div>
          </el-form-item> -->
          <el-form-item class="textArea" style="width: 96%" label="备注:">
            <el-input
              placeholder="请输入"
              clearable
              v-model="addReqs.remarks"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;
        "
        v-if="true || (addReqs.waybillList && addReqs.waybillList.length > 1)"
      >
        <el-button class="jsBtns glo_bgcMainColor" @click="clickOneSharing"
          >一键摊分</el-button
        >
      </div>
    </div>
    <!-- 运单信息 -->
    <div
      class="infoDiv"
      v-for="(item, index) in addReqs.waybillList"
      :key="index"
    >
      <div class="h3title">运单{{ index + 1 }}</div>
      <div class="formbox">
        <el-form label-width="120px" class="glo_formBox">
          <el-form-item label="运单号:">
            <el-input
              disabled
              v-model="item.waybillNumber"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户单号:">
            <el-input
              disabled
              v-model="item.customerOrderNumber"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="到货区域:">
            <el-input disabled v-model="item.arrivalArea" clearable></el-input>
          </el-form-item>
          <el-form-item label="提货日期:">
            <el-date-picker
              disabled
              v-model="item.takeTime"
              value-format="yyyy-MM-dd"
              type="date"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="开单客户:">
            <el-input disabled v-model="item.customerName" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户联系人:">
            <el-input disabled v-model="item.contactsName" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input disabled v-model="item.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="交货日期:">
            <el-date-picker
              disabled
              v-model="item.deliveryTime"
              value-format="yyyy-MM-dd"
              type="date"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="formbox" style="margin-bottom: 20px">
        <el-table :data="item.itemList" border style="width: 100%">
          <el-table-column prop="goodsName" label="货物名称"></el-table-column>
          <el-table-column prop="packageName" label="包装"></el-table-column>
          <el-table-column prop="packageCout" label="件数"></el-table-column>
          <el-table-column prop="grossWeight" label="毛重"></el-table-column>
          <el-table-column prop="netWeight" label="净重"></el-table-column>
          <el-table-column
            prop="volumeWeight"
            label="体积重量/KG"
          ></el-table-column>
          <el-table-column
            prop="billingWeight"
            label="计费取值"
          ></el-table-column>
          <el-table-column prop="volume" label="体积/m³"></el-table-column>
          <el-table-column prop="specs" label="规格尺寸">
            <template #default="{ row }">
              {{
                !row.itemSpecss || row.itemSpecss.length === 0
                  ? "无"
                  : row.itemSpecss
                      .map((item) => {
                        return (
                          item.length +
                          " x " +
                          item.wide +
                          " x " +
                          item.height +
                          " x " +
                          item.packageCout
                        );
                      })
                      .join(",  ")
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="formbox">
        <el-form label-width="120px" class="glo_formBox">
          <el-form-item label="分拣包装:">
            <el-input disabled v-model="item.packageName" clearable></el-input>
          </el-form-item>
          <el-form-item label="分拣数量:">
            <el-input disabled v-model="item.packageCout" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="送货方式:" required>
              <el-select filterable clearable v-model="item.sendMethodConfDictId" placeholder="请输入">
                <el-option v-for="item in OUTsendMethodList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
            </el-form-item>-->
          <!-- <el-form-item label="实际计费方式:" required>
              <el-select filterable clearable v-model="item.formulaBillingWeightId" placeholder="请选择">
                <el-option v-for="item in out_going_billing_method_list" :key="item.formulaBillingWeightId" :label="item.formulaBillingWeightName" :value="String(item.formulaBillingWeightId)"></el-option>
              </el-select>
            </el-form-item>-->
          <template
            v-if="
              true || (addReqs.waybillList && addReqs.waybillList.length > 1)
            "
          >
            <el-form-item label="摊分承运商称重:">
              <el-input v-model="item.shareCarrierWeigh" clearable></el-input>
            </el-form-item>
            <el-form-item label="摊分承运商体积:">
              <el-input v-model="item.shareCarrierVolume" clearable></el-input>
            </el-form-item>
            <el-form-item label="承运商单价:">
              <el-input
                disabled
                v-model="item.carrierUnitPrice"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="实际运费:">
              <el-input
                v-model="item.basicFreight"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="实际送货费:">
              <el-input
                v-model="item.sendFee"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="实际其他费用:">
              <div class="disFlexs jsInput">
                <el-input
                  v-model="item.otherFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                ></el-input>
                <!-- <el-button
                  class="jsBtns glo_bgcMainColor"
                  @click="clickSet(index)"
                  >明细</el-button
                > -->
              </div>
            </el-form-item>
            <el-form-item label="实际外发总额:" required>
              <div class="disFlexs jsInput">
                <el-input
                  v-model="item.totalFreight"
                  @input="input_apportionmentTotal"
                  placeholder="请输入"
                  clearable
                  type="number"
                ></el-input>
                <el-button
                  class="jsBtns glo_bgcMainColor"
                  @click="clickTotalExpenses(index)"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="" label-width="0" style="border: none">
              <el-checkbox
                v-model="item.isReceivedPayWithCarrier"
                :disabled="addReqs.isReceivedPayWithCarrier === 1"
                :true-label="1"
                :false-label="0"
                >到付费用与承运商结算</el-checkbox
              >
            </el-form-item>
            <el-form-item label="代收货款:">
              <el-input
                disabled
                v-model="item.agentAmount"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="到付运费:">
              <el-input
                disabled
                v-model="item.receivedAmount"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="到付总额:">
              <el-input
                disabled
                v-model="item.receivedAmountSum"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="应付余额:">
              <el-input
                disabled
                v-model="item.shouldOutAmount"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="应收余额:">
              <el-input
                disabled
                v-model="item.shouldInAmount"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="预计计费方式:">
            <div class="disFlexs jsInput">
              <el-select
                disabled
                filterable
                clearable
                v-model="item.planFormulaBillingWeightId"
                placeholder
              >
                <el-option
                  v-for="item in out_going_billing_method_list"
                  :key="item.formulaBillingWeightId"
                  :label="item.formulaBillingWeightName"
                  :value="String(item.formulaBillingWeightId)"
                ></el-option>
              </el-select>
              <el-button
                class="jsBtns glo_bgcMainColor"
                @click="clickSharing_sendFeeYJ(item, index)"
                >计算</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="预计送货费:">
            <el-input
              disabled
              v-model="item.planSendFee"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="预计运费:">
            <el-input
              disabled
              v-model="item.planBasicFreight"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="预计其他费用:">
            <el-input
              disabled
              v-model="item.planOtherFee"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="预计费用合计:">
            <el-input
              disabled
              v-model="item.planTotalAmount"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item> -->
          </template>
        </el-form>
      </div>
    </div>
    <!-- 其他费用 -->
    <otherFee
      :isShowDialog_otherFee="isShowDialog_otherFee"
      :diaWidth_otherFee="diaWidth_otherFee"
      :dialogTitle_otherFee="dialogTitle_otherFee"
      :otherFeeReqs="otherFeeReqs"
      @handleCloseDia_otherFee="handleCloseDia_otherFee"
      @diaConfirmBtn_otherFee="diaConfirmBtn_otherFee"
    ></otherFee>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import otherFee from "@/components/otherFee.vue";
import isImmediate from "@/assets/js/tool.js";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    otherFee,
  },
  props: {
    k: {
      type: Array,
      require: false,
      default() {
        return null;
      },
    },
    v: {
      require: false,
      default() {
        return null;
      },
    },
    t:{
      require:false,
      default(){
        return 0
      }
    },
    outgoingId: {},
  },
  data() {
    return {
      loading:false,
      isAddCarrier: true,
      provinceArr: [],
      cityArr: [],
      districtArr: [],
      sendMethodConfDictId: "",
      formulaBillingWeightId: "",
      specIndex1: 0,
      diaWidth_otherFee: "80%",
      dialogTitle_otherFee: "其他费用",
      isShowDialog_otherFee: false,
      otherFeeReqs: [],

      totalAmount: 0,
      apportionmentTotal: 0,
      carrierAttributeConfDictKey: "zheng_shi",
      carrierArea: "",
      addReqs: {
        startDeptId:'',
        waybillList: [],
        isReceivedPayWithCarrier: 0,
      },

      OUTsendMethodList: [], //送货方式
      OUTTakeMethodList: [], //外发提货方式
      out_going_settlement_method_list: [], //外发结算方式
      out_going_billing_method_list: [], //外发计费方式
      packageNameList: [], //包装
      storageList: [], //入仓仓库
      CarrierDeptListList: [], //网点
      changeCarrierList: [], //外发承运商
      employeeList: [],
      businessDeptIdArr: [],
      submitLoading: false,
      addReqscontacts: "",
      waybillSplitIds: this.k || (this.v && [this.v]) || [],
      waybills: [],
      waybillNumberKeyword: "",
    };
  },
  computed: {
    totalGrossWeightSum() {
      const waybillList = this.addReqs.waybillList;
      if (!waybillList || waybillList.length === 0) {
        return 0;
      }
      let sum = 0;
      waybillList.map((bill) => {
        const itemList = bill.itemList;
        if (itemList && itemList.length > 0) {
          itemList.map((aa) => (sum += aa.grossWeight));
        }
      });
      return sum;
    },
    totalVolumeSum() {
      const waybillList = this.addReqs.waybillList;
      if (!waybillList || waybillList.length === 0) {
        return 0;
      }
      let sum = 0;
      waybillList.map((bill) => {
        const itemList = bill.itemList;
        if (itemList && itemList.length > 0) {
          itemList.map((aa) => (sum += aa.volume));
        }
      });
      return sum;
    },
    carrierUnitPrice() {
      return (
        this.$TOOLS.divide(
          this.addReqs.basicFreight,
          this.addReqs.allCarrierWeigh
        ) || 0
      );
    },
    totalFreight() {
      return (
        this.$TOOLS.add(
          this.addReqs.basicFreight,
          this.addReqs.allOtherFee,
          this.addReqs.sendFee
        ) || 0
      );
    },
    agentAmount() {
      const waybillList = this.addReqs.waybillList;
      if (!waybillList || waybillList.length === 0) {
        return 0;
      }
      let sum = 0;
      waybillList.map((bill) => {
        sum = this.$TOOLS.add(sum, bill.agentAmount);
      });
      return sum;
    },
    receivedAmount() {
      const waybillList = this.addReqs.waybillList;
      if (!waybillList || waybillList.length === 0) {
        return 0;
      }
      let sum = 0;
      waybillList.map((bill) => {
        sum = this.$TOOLS.add(sum, bill.receivedAmount);
      });
      return sum;
    },
    receivedAmountSum() {
      return this.$TOOLS.add(this.agentAmount, this.receivedAmount);
    },
    shouldOutAmount() {
      if (this.receivedAmountSum > this.totalFreight) {
        return 0;
      }
      if (!this.addReqs.isReceivedPayWithCarrier) {
        return 0;
      }
      return this.$TOOLS.sub(this.totalFreight, this.receivedAmountSum);
    },
    shouldInAmount() {
      if (this.receivedAmountSum > this.totalFreight) {
        return this.$TOOLS.sub(this.receivedAmountSum, this.totalFreight);
      }
      if (this.addReqs.isReceivedPayWithCarrier == 0) {
        return 0;
      }
      return 0;
    },
  },
  watch: {
    outgoingId: {
      handler(val) {
        this.getDetail();
      },
    },
    k: {
      handler(val) {
        if (val) {
          this.waybillSplitIds = val;
        }
      },
    },
    v: {
      handler(val) {
        if (val) {
          this.waybillSplitIds = [val];
        }
      },
    },
  },
  created() {},
  async mounted() {
    this.getParentName("中华人民共和国"); //默认查到各省
    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("package_name"); //获取包装
    this.getConfDictValDownList("out_going_take_method"); //提货方式
    this.getConfDictValDownList("out_going_send_method"); //送货方式
    this.getConfDictValDownList("out_going_settlement_method"); //外发结算方式

    //  动态查询返回字段
    this.$COMAPI.getReportFiledsAPi("admin_outgoing_wait_detail");
    this.$COMAPI.getReportFiledsAPi("admin_outgoing_wait_detail_waybill");
    this.$COMAPI.getReportFiledsAPi("admin_outgoing_detail");
    this.$COMAPI.getReportFiledsAPi("admin_outgoing_detail_waybill");
    this.$COMAPI.getReportFiledsAPi("admin_outgoing_wait_detail_waybill_item");
    this.initcread();
    await this.remoteMethod("", "storage", "storageList");
    this.getDetail();
    // 监听复杂对象数组
    this.$watch(
      "addReqs",
      (newVal, oldVal) => {
        // 遍历 waybillList 数组
        newVal.waybillList.forEach((item, idxA) => {
          // 监听 formulaBillingWeightId 字段的变化
          this.$watch(
            () => item.formulaBillingWeightId,
            (newVal, oldVal) => {
              // 在这里处理 formulaBillingWeightId 字段值的变化
              console.log("formulaBillingWeightId 变化", newVal);
              this.billWeightCalculationById(idxA);
            }
          );
        });
      },
      { deep: true }
    );
  },
  activated() {},
  destroyed() {},
  methods: {
    reset() {
      this.$emit("reset");
    },
    changeWaybillNumberKeyword(){
      this.waybillSplitIds = [this.waybillNumberKeyword]
      this.getDetail()
    },
    async remoteSearchWaybillMethod(query){
      if(!query){
        return
      }
      this.loading = true
      const res = await this.$API.runList({
        number:'admin_waybill_list_v5',
        waybillNumber:query
      })
      this.loading = false
      this.waybills = res
      if(this.waybills.length == 1){
        //this.waybillNumberKeyword = this.waybills[0].waybillSplitId
      }
    },
    changeCarrierAttributeConf() {
      if (this.addReqs.carrierAttributeConfDictKey === "lin_shi") {
        this.isAddCarrier = true;
      }
    },
    async getDetail() {
      this.addReqs.outgoingTime = this.$moment().format("YYYY-MM-DD");
      this.addReqs.startDeptId = this.$TOOLS.getUserInfo().departmentId ?
        this.$TOOLS.getUserInfo().departmentId + ""  : null;
      await this.getOutgoingInfo();
      this.getPackageDetails();
    },
    async getOutgoingInfo() {
      if (!this.outgoingId) {
        return;
      }
    },
    //网点
    focusMethodDept() {
      if (this.businessDeptIdArr.length == 0) {
        this.remoteMethodDept("");
      }
    },
    // 网点
    remoteMethodDept(deptName) {
      this.$API
        .wtl_getDeptList({
          deptName,
          deptId: "",
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.businessDeptIdArr = res.data.result?.data || [];
        });
    },
    // // 获取行政区
    // getDistrictDownList(param) {
    //   return this.$API.DistrictDownList({ parentId: param }).then((res) => {
    //     if (res.data.status === "success") {
    //       let result = res.data.result;
    //       let district = result[0]?.level || "";
    //       if (district === "province") this.provinceArr = result;
    //       if (district === "city") this.cityArr = result;
    //       if (district === "district") this.districtArr = result;
    //     }
    //   });
    // },
    // // 目的
    // async districtClick(val, level) {
    //   let id = parseInt(val);
    //   if (level === "province") {
    //     await this.getDistrictDownList(id);
    //     this.cityArr = [];
    //     this.addReqs.carrierCity = "";
    //   }
    //   if (level === "city") {
    //     await this.getDistrictDownList(id);
    //     this.districtArr = [];
    //     this.addReqs.carrierArea = "";
    //   }
    // },
    async initcread() {
      await this.runPageReportDetailsitemId("formula_billing_weight_down_list");
    },
    // 动态接口获取下拉列表
    runPageReportDetailsitemId(number, array) {
      // customer_channel_down_list => 客户报价方式下拉列表
      // 参数key:
      // customerId(客户id 必填)
      // channelName(报价方式名称 非必填)

      // customer_dispatch_channel_down_list => 客户线路报价下拉列表(报价到货区域)
      // 参数key:
      // channelId(报价方式id 必填)
      // offerName(线路报价名称 非必填)

      // formula_billing_weight_down_list => 获取计费重量公式下拉列表

      return this.$API
        .runPageReportDetails({
          number: number,
          conditionReqs: array || [],
        })
        .then((res) => {
          let datas = res.data.result.datas || [];
          if (number == "formula_billing_weight_down_list") {
            // 计费方式
            this.out_going_billing_method_list = datas;
          }
        });
    },
    inputTotalAmount() {
      //总费用
      let { sendFee, basicFreight } = this.addReqs;
      this.totalAmount = this.$TOOLS.mathToFixed(
        this.$TOOLS.add(sendFee, basicFreight)
      );
      this.$forceUpdate();
    },
    input_apportionmentTotal() {
      //总摊分合计
      this.apportionmentTotal = this.sumpub(
        this.addReqs.waybillList,
        "totalFreight"
      );
    },
    //一键摊分
    clickOneSharing() {
      this.clickSharing_sendFee();
      this.clickSharing_basicFreight();
      this.clickSharing_otherFee();
      this.click_allCarrierWeigh();
      this.click_allCarrierVolume();
    },
    //一键获取预计费用
    clickOneAccessEstimatedExpenses() {
      this.addReqs.waybillList.forEach((element, index) => {
        this.clickSharing_sendFeeYJ(element, index);
      });
    },
    clickTotalExpenses(index) {
      //实际费用合计
      console.log(index);
      let curs = this.addReqs.waybillList[index];
      let sum1 = this.$TOOLS.add(curs.basicFreight, curs.sendFee);
      this.addReqs.waybillList[index].totalFreight = this.$TOOLS.add(
        sum1,
        curs.otherFee
      );
      this.$set(
        this.addReqs.waybillList[index],
        "totalFreight",
        this.$TOOLS.add(sum1, curs.otherFee)
      );
      this.calcShouldInAndOut(curs);
    },
    // curBillingSumsgg(key) {
    //   // 计算 单价均摊
    //   let { waybillList } = this.addReqs;
    //   let arrs = waybillList.map((n) => {
    //     return this.sumpub(n.itemList, key, 0);
    //   });
    //   let sum = arrs.reduce((prev, curr) => this.$TOOLS.add(prev, curr));
    //   arrs.forEach((element, index) => {
    //     this.addReqs.waybillList[index].unitPrice  =
    //       element == 0
    //         ? ""
    //         : this.$TOOLS.mathToFixed(
    //             this.$TOOLS.divide(
    //               this.addReqs.waybillList[index].totalFreight,
    //               sum
    //             )
    //           );
    //   });
    // },

    async click_allCarrierWeigh() {
      //承运商称重 自动摊分 承运商单价 = 运费/承运商称重   （基本信息==运单）
      let { waybillList, allCarrierWeigh = 0, basicFreight = 0 } = this.addReqs;
      if (!allCarrierWeigh) {
        this.$message.error("请输入承运商称重");
        return false;
      }
      if (!basicFreight) {
        this.$message.error("请输入运费");
        return false;
      }
      if (!this.formulaBillingWeightId) {
        this.$message.error("请选择计费方式");
        return false;
      }
      let arrs = [];
      const promisemap = waybillList.map(async (element, index) => {
        let objj = await this.billWeightCalculationById(index);
        arrs.push(objj);
      });
      await Promise.all(promisemap);
      let sums = this.sumpubGGG(arrs, "value", 0);
      arrs.forEach((element) => {
        let getallCarrierWeigh = 0;
        if (element.value != 0 && sums != 0 && allCarrierWeigh != 0) {
          getallCarrierWeigh = this.$TOOLS.mathToFixed(
            this.$TOOLS.mul(
              this.$TOOLS.divide(element.value, sums),
              allCarrierWeigh
            )
          );
        }
        this.addReqs.carrierUnitPrice = this.$TOOLS.mathToFixed(
          this.$TOOLS.divide(basicFreight, allCarrierWeigh)
        );
        this.addReqs.waybillList[element.key].shareCarrierWeigh =
          getallCarrierWeigh;
        this.addReqs.waybillList[element.key].carrierUnitPrice =
          this.addReqs.carrierUnitPrice;
        this.calcShouldInAndOut(element);
      });
      this.$forceUpdate();
    },
    async click_allCarrierVolume() {
      //承运商称重 自动摊分 承运商单价 = 运费/承运商称重   （基本信息==运单）
      let {
        waybillList,
        allCarrierVolume = 0,
        basicFreight = 0,
      } = this.addReqs;
      if (!allCarrierVolume) {
        this.$message.error("请输入承运商体积");
        return false;
      }
      // if (!basicFreight) {
      //   this.$message.error("请输入运费");
      //   return false;
      // }
      if (!this.formulaBillingWeightId) {
        this.$message.error("请选择计费方式");
        return false;
      }
      let arrs = [];
      const promisemap = waybillList.map(async (element, index) => {
        let objj = await this.billWeightCalculationById(index);
        arrs.push(objj);
      });
      await Promise.all(promisemap);
      let sums = this.sumpubGGG(arrs, "value", 0);
      arrs.forEach((element) => {
        let getallCarrierWeigh = 0;
        if (element.value != 0 && sums != 0 && allCarrierVolume != 0) {
          getallCarrierWeigh = this.$TOOLS.mathToFixed(
            this.$TOOLS.mul(
              this.$TOOLS.divide(element.value, sums),
              allCarrierVolume
            )
          );
        }
        this.addReqs.waybillList[element.key].shareCarrierVolume =
          getallCarrierWeigh;
        this.calcShouldInAndOut(element);
      });
      this.$forceUpdate();
    },
    async clickSharing_basicFreight() {
      //运费 自动摊分
      let { waybillList, basicFreight = 0 } = this.addReqs;
      // if (!waybillList.every((item) => item.formulaBillingWeightId)) {
      //   this.$message.error("请选择运单实际计费方式");
      //   return false;
      // }
      if (!this.formulaBillingWeightId) {
        this.$message.error("请选择计费方式");
        return false;
      }
      let arrs = [];
      const promisemap = waybillList.map(async (element, index) => {
        let objj = await this.billWeightCalculationById(index);
        arrs.push(objj);
      });
      await Promise.all(promisemap);
      let sums = this.sumpubGGG(arrs, "value", 0);
      arrs.forEach((element) => {
        console.log(element.value, sums, basicFreight);
        let getbasicFreight = 0;
        if (element.value != 0 && sums != 0 && basicFreight != 0) {
          getbasicFreight = this.$TOOLS.mathToFixed(
            this.$TOOLS.mul(
              this.$TOOLS.divide(element.value, sums),
              basicFreight
            )
          );
        }
        this.addReqs.waybillList[element.key].basicFreight = getbasicFreight;
        this.addReqs.waybillList[element.key].unitPrice = 0;
        if (getbasicFreight != 0) {
          this.addReqs.waybillList[element.key].unitPrice = this.$TOOLS.divide(
            getbasicFreight,
            this.sumpubGGG(
              this.addReqs.waybillList[element.key].itemList,
              "billingWeight",
              0
            )
          );
        }
        //  单价 = 实际运费/均摊取值

        this.clickTotalExpenses(element.key);
        this.calcShouldInAndOut(element);
      });
      this.$forceUpdate();
    },
    // 运费计算(自定义选择报价)
    async billWeightCalculationById(index) {
      let grossWeight = this.curBillingSums("grossWeight", index);
      let netWeight = this.curBillingSums("netWeight", index);
      let packageCount = this.curBillingSums("packageCout", index);
      let volume = this.curBillingSums("volume", index);
      let param = {
        // formulaBillingWeightId:
        //   this.addReqs.waybillList[index].formulaBillingWeightId,
        formulaBillingWeightId: this.formulaBillingWeightId,
        grossWeight: grossWeight || 0,
        netWeight: netWeight || 0,
        packageCount: packageCount || 0,
        volume: volume || 0,
      };
      return this.$API.billWeightCalculationById(param).then((res) => {
        let datas = res.data.result || {};
        let addReqs = JSON.parse(JSON.stringify(this.addReqs));
        addReqs.waybillList[index].billingWeight =
          Number(datas.billingWeight) || 0;
        this.addReqs = addReqs;
        this.addReqscontacts = addReqs.contacts || "";
        return {
          key: index,
          value: Number(datas.billingWeight) || 0,
        };
      });
    },
    curBillingSums(key, index) {
      // 计算 运费均摊
      let itemList = this.addReqs.waybillList[index].itemList;
      return this.sumpubGGG(itemList, key, 0);
    },
    sumpubGGG(arr, key, tofid = 2) {
      return arr
        .map((n) => {
          return n[key];
        })
        .reduce((prev, curr) => this.$TOOLS.add(prev, curr));
    },
    // clickSharing_basicFreight() {
    //   //运费 自动摊分
    //   let { waybillList, basicFreight } = this.addReqs;
    //   let cursBillingId = waybillList[0].formulaBillingWeightId;
    //   if (!cursBillingId) {
    //     this.$message.error("请选择运单实际计费方式");
    //     return false;
    //   }
    //   if (
    //     !waybillList.every(
    //       (item) => item.formulaBillingWeightId === cursBillingId
    //     )
    //   ) {
    //     this.$message.error("运单实际计费方式不一致，无法自动分摊");
    //     return false;
    //   }
    //   let curBilling = this.out_going_billing_method_list.filter((n) => {
    //     return n.formulaBillingWeightId == cursBillingId;
    //   })[0].key;
    //   switch (curBilling) {
    //     case "按票数":
    //       let cursend = this.$TOOLS
    //         .divide(basicFreight, waybillList.length)
    //         .toFixed(2);
    //       this.addReqs.waybillList.forEach((element, index) => {
    //         element.basicFreight = cursend;
    //         this.clickTotalExpenses(index);
    //       });
    //       break;
    //     case "按件数":
    //       this.curBillingSums("packageCout");
    //       break;
    //     case "按毛重":
    //       this.curBillingSums("grossWeight");
    //       break;
    //     case "按净重":
    //       this.curBillingSums("netWeight");
    //       break;
    //     case "按体积":
    //       this.curBillingSums("volume");
    //       break;
    //     default:
    //       break;
    //   }
    // },
    // curBillingSums(key) {
    //   // 计算 运费均摊
    //   let { waybillList, basicFreight } = this.addReqs;
    //   let arrs = waybillList.map((n) => {
    //     return this.sumpub(n.itemList, key, 0);
    //   });
    //   let sum = arrs.reduce((prev, curr) => this.$TOOLS.add(prev, curr));
    //   arrs.forEach((element, index) => {
    //     let getbasicFreight = this.$TOOLS.mathToFixed(
    //       this.$TOOLS.mul(this.$TOOLS.divide(element, sum), basicFreight)
    //     );
    //     this.addReqs.waybillList[index].basicFreight =
    //       element == 0 ? "" : getbasicFreight;
    //     this.clickTotalExpenses(index);
    //   });
    //   this.$message.success("运费自动均摊成功");
    // },
    sumpub(arr, key, tofid = 2) {
      return this.$TOOLS.mathToFixed(
        arr
          .map((n) => {
            return n[key] || 0;
          })
          .reduce((prev, curr) => this.$TOOLS.add(prev, curr)),
        tofid
      );
    },
    clickSharing_sendFee() {
      //送货费
      let { waybillList, sendFee } = this.addReqs;
      let cursend = this.$TOOLS.divide(sendFee, waybillList.length).toFixed(2);
      this.addReqs.waybillList.forEach((element, index) => {
        element.sendFee = cursend;
        this.clickTotalExpenses(index);
      });
      this.$message.success("送货费自动均摊成功");
    },
    clickSharing_otherFee() {
      //送货费
      let { waybillList, allOtherFee } = this.addReqs;
      let cursend = this.$TOOLS
        .divide(allOtherFee, waybillList.length)
        .toFixed(2);
      this.addReqs.waybillList.forEach((element, index) => {
        element.otherFee = cursend;
        this.clickTotalExpenses(index);
      });
      this.$message.success("其他费自动均摊成功");
    },
    //  获取详情
    async getPackageDetails() {
      if ((!this.waybillSplitIds || this.waybillSplitIds.length == 0) && !this.outgoingId) {
        return;
      }
      let gdatas = {};
      if (this.waybillSplitIds.length > 0) {
        await this.$API
          .outgoinggetOutgoingBeforeDetailV5({
            waybillSplitIds: this.waybillSplitIds,
            justDoOutgoing : this.t == 1 ? 1 : ''
          })
          .then((res) => {
            if (res.data.status === "success") {
              console.log(res.data.result)
              gdatas = res.data.result[0] || {};
              gdatas.outgoingTime = this.$moment().format("YYYY-MM-DD");
              gdatas.startDeptId =
                this.$TOOLS.getUserInfo().departmentId + "" || "";
              if(!gdatas.waybillList){
                this.$message.error(`运单不存在外发单`);
                return 
              }
              gdatas.waybillList.forEach((element) => {
                element.planTotalAmount = element.totalFreight;
                element.planFormulaBillingWeightId =
                  (element.formulaBillingWeightId &&
                    String(element.formulaBillingWeightId)) ||
                  "";
                element.planSendFee = element.sendFee;
                element.planBasicFreight = element.basicFreight;
                element.planOtherFee = element.otherFee;
              });
              if (gdatas.waybillList.length === 1) {
                //todo
                const rowOne = gdatas.waybillList[0];
                // sendFee: element.sendFee,
                // outgoingSendMethodConfDictId: element.sendMethodConfDictId,
                // outgoingSendMethod: (curs3.length && curs3[0].val) || "",
                // // formulaBillingWeightId: element.formulaBillingWeightId,
                // formulaBillingWeightId: this.formulaBillingWeightId,
                // basicFreight: element.basicFreight,
                // allOtherFee: element.otherFee,
                // shareCarrierWeigh: element.shareCarrierWeigh,
                // shareCarrierVolume:element.shareCarrierVolume,
                // rowOne.
              }
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        let tmsadmin_sendEmployeeName = window.localStorage.getItem(
          "tmsadmin_sendEmployeeName"
        );
        gdatas.sendEmployeeName =
          gdatas.sendEmployeeName || tmsadmin_sendEmployeeName != undefined
            ? tmsadmin_sendEmployeeName
            : "" || "";
        gdatas.sendEmployeeId =
          gdatas.sendEmployeeId ||
          Number(window.localStorage.getItem("tmsadmin_sendEmployeeId")) ||
          "";
        await this.remoteMethod(
          gdatas.sendEmployeeName,
          "employee",
          "employeeList"
        );
      } else if (this.outgoingId) {
        await this.$API
          .outgoinggetOutgoingDetailV5({
            outgoingId: this.outgoingId,
          })
          .then((res) => {
            if (res.data.status === "success") {
              gdatas = res.data.result[0] || {};
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        await this.remoteMethod(
          gdatas.sendEmployeeName || "",
          "employee",
          "employeeList"
        );
      }
      const this_ = this;
      if(!gdatas.waybillList || gdatas.waybillList.length == 0){
        return
      }
      gdatas.waybillList.forEach((element) => {
        if (this.outgoingId) {
          this.$API
            .runPageReportDetails({
              conditionReqs: [
                {
                  conditonKey: "outgoingId",
                  conditonVal: this.outgoingId,
                },
              ],
              number: "admin_outgoing_detail_item_service",
            })
            .then((res) => {
              if (res.data.status === "success") {
                let datas = res.data.result.datas || [];
                element.otherFeeReqs = (datas.length && datas) || [];
              } else {
                this_.$message.error(`${res.data.message}---综合查询列表`);
              }
            });
        } else {
          element.otherFeeReqs = [];
        }
        this.calcShouldInAndOut(element);
      });
      if (gdatas.carrierName) {
        await this.remoteMethodCarrier(gdatas.carrierName);
        await this.changeMethodCarrier(gdatas.carrierName);
      }
      await this.remoteMethod(
        gdatas.startDeptName || "",
        "storage",
        "storageList"
      );
      this.addReqs = gdatas;
      this.addReqs.startDeptId = gdatas.startDeptId || null 
      this.addReqs.carrierDeptId = gdatas.carrierDeptId || "";
      this.addReqs.carrierPhone = gdatas.carrierPhone || gdatas.phone || "";
      this.addReqs.isReceivedPayWithCarrier =
        gdatas.isReceivedPayWithCarrier || 0;
      this.addReqscontacts = gdatas.contacts || "";

      this.carrierArea = gdatas.carrierArea || "";
      this.isAddCarrier = gdatas.isAddCarrier == 1 ? true : false;
      this.carrierAttributeConfDictKey =
        gdatas.carrierAttributeConfDictKey || "zheng_shi";
      if (gdatas.waybillList && gdatas.waybillList.length) {
        let { sendMethodConfDictId, formulaBillingWeightId } =
          gdatas.waybillList[0] || {};
        if (sendMethodConfDictId) {
          this.sendMethodConfDictId = sendMethodConfDictId;
        }
        this.formulaBillingWeightId =
          (formulaBillingWeightId && Number(formulaBillingWeightId)) || "";
      }
      this.inputTotalAmount();
      this.input_apportionmentTotal();
    },
    clickSharing_sendFeeYJ(item, index) {
      if (!this.addReqs.carrierId) {
        this.$message.error(`请选择承运商`);
        return false;
      }
      if (!this.formulaBillingWeightId) {
        this.$message.error("请选择计费方式");
        return false;
      }
      this.addReqs.waybillList[index].planFormulaBillingWeightId = String(
        this.formulaBillingWeightId
      );
      this.$API
        .formulafreightCarrierCalculation({
          carrierId: this.addReqs.carrierId,
          formulaBillingWeightId: this.formulaBillingWeightId,
          waybillSplitId: item.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || {};
          if (datas.sendAmount) {
            this.addReqs.waybillList[index].planSendFee = datas.sendAmount;
          }
          if (datas.freight) {
            this.addReqs.waybillList[index].planBasicFreight = datas.freight;
          }
        });
    },
    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    // //员工、部门、外发网点
    // changeMethod(e, arrs, keys) {
    //   let curs = this[arrs].filter((item) => item.documentId == e);
    //   if (keys == "intoDeptName") {
    //     this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
    //   } else {
    //     this.commandReq[keys] = (curs.length && curs[0].name) || "";
    //   }
    // },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 1000,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },

    //外发承运商
    focusMethodCarrier(e) {
      if (this.changeCarrierList.length == 0) {
        this.remoteMethodCarrier("");
      }
    },
    //外发承运商
    changeMethodCarrier(e) {
      if (e) {
        // 获取承运商——网点
        let curs = this.changeCarrierList.find((item) => item.carrierName == e);
        if (curs) {
          this.addReqs.carrierId = curs.carrierId || "";
          this.addReqs.settlementMethodConfDictId =
            curs.settlementMethodConfDictId || "";
        }
        if (!this.addReqs.carrierId) {
          return false;
        }
        return this.$COMAPI
          .CarrierDeptList(this.addReqs.carrierId)
          .then((res) => {
            this.addReqs.carrierDeptId = "";
            this.addReqs.carrierDeptName = "";
            this.CarrierDeptListList = res || [];
            this.CarrierDeptListList.forEach((element) => {
              if (
                element.isDefault == 1 &&
                this.carrierAttributeConfDictKey == "zheng_shi"
              ) {
                this.addReqs.carrierDeptId = element.carrierDeptId;
                this.addReqs.carrierDeptName = element.deptName;
                this.changeMethodCarrier1(this.addReqs.carrierDeptName);
              }
            });
          });
      }
    },
    //外发承运商 carrierId carrierName carrierId
    remoteMethodCarrier(carrierName) {
      return this.$API
        .CarrierList({
          carrierName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.changeCarrierList = res.data.result.data || [];
        });
    },

    //外发承运商网点
    focusMethodCarrier1(e) {
      if (this.CarrierDeptListList.length == 0) {
        this.remoteMethodCarrier1("");
      }
    },
    //外发承运商网点
    changeMethodCarrier1(e) {
      this.CarrierDeptListList.forEach(async (element) => {
        if (element.deptName == e) {
          if (element.provinceName) {
            await this.changeProvince(element.provinceName);
          }
          if (element.cityName) {
            await this.changeCity(element.cityName);
          }
          this.addReqs.carrierProvince = element.provinceName || "";
          this.addReqs.carrierCity = element.cityName || "";
          this.carrierArea = element.areaName || "";
          this.addReqs.carrierAddress = element.address || "";
          this.addReqs.carrierDeptId = element.carrierDeptId || "";
          this.addReqs.carrierPhone = element.phone || "";
          this.addReqscontacts = element.contacts || "";
        }
      });
    },
    //外发承运商网点
    remoteMethodCarrier1(deptName) {
      if (this.carrierAttributeConfDictKey == "lin_shi") {
      }
      if (this.addReqs.carrierId) {
        return this.$API
          .CarrierDeptList({
            carrierId: this.addReqs.carrierId || "",
            pageStart: 1,
            pageTotal: 200,
            deptName,
          })
          .then((res) => {
            this.CarrierDeptListList = res.data.result.data || [];
          });
      }
    },

    //品类
    focusMethodCategory(index) {
      if (this.itemReqs[index].CategoryList.length == 0) {
        this.remoteMethodCategory("", index);
      }
    },
    //品类
    changeMethodCategory(e, index) {
      let curs = this.itemReqs[index].CategoryList.filter(
        (item) => item.itemCategoryName == e
      );
      this.itemReqs[index].itemCategoryCode =
        (curs.length && curs[0].itemCategoryCode) || "";
      console.log(this.itemReqs[index].itemCategoryCode);
    },
    //品类
    remoteMethodCategory(categoryName, index) {
      this.$API
        .wtl_getCategoryList({
          categoryName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.itemReqs[index].CategoryList = res.data.result.data || [];
        });
    },

    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
          }
          if (dictType == "out_going_take_method") {
            // 外发提货
            this.OUTTakeMethodList = arrs;
          }
          if (dictType == "out_going_send_method") {
            // 外发送货方式
            this.OUTsendMethodList = arrs;
            arrs.forEach((element) => {
              if (element.type == "out_going_send_method") {
                this.sendMethodConfDictId = element.confDictId;
              }
            });
          }
          if (dictType == "out_going_settlement_method") {
            // 外发结算方式
            this.out_going_settlement_method_list = arrs;
          }
        });
    },

    // =========================================
    // 其他费用部分
    // 查看明细
    clickSet(index) {
      this.isShowDialog_otherFee = true;
      // let otherFee = this.addReqs.waybillList[index].otherFee;
      this.specIndex1 = index;
      this.otherFeeReqs = this.addReqs.waybillList[index].otherFeeReqs || [];
    },

    changeIsCarrierSettlement() {
      const isReceivedPayWithCarrier = this.addReqs.isReceivedPayWithCarrier;
      if (!isReceivedPayWithCarrier) {
        this.addReqs.shouldInAmount = 0;
        this.addReqs.shouldOutAmount = 0;
      }
      this.addReqs.waybillList.map((item) => {
        this.$set(item, "isReceivedPayWithCarrier", isReceivedPayWithCarrier);
        this.calcShouldInAndOut(item);
      });
    },
    // 计算应付和应收,运单维度
    calcShouldInAndOut(row) {
      if (row.isReceivedPayWithCarrier == 0) {
        this.$set(row, "shouldInAmount", 0);
        this.$set(row, "shouldOutAmount", 0);
        return;
      }
      const totalFreight = parseFloat(row.totalFreight) || 0;
      const receivedAmountSum = this.$TOOLS
        .add(row.receivedAmount, row.agentAmount)
        .toFixed(2);
      this.$set(row, "receivedAmountSum", receivedAmountSum);
      if (receivedAmountSum > totalFreight) {
        this.$set(
          row,
          "shouldInAmount",
          this.$TOOLS.sub(receivedAmountSum, totalFreight).toFixed(2)
        );
        this.$set(row, "shouldOutAmount", 0);
      } else {
        this.$set(row, "shouldInAmount", 0);
        this.$set(
          row,
          "shouldOutAmount",
          this.$TOOLS.sub(totalFreight, receivedAmountSum).toFixed(2)
        );
      }
    },
    // 其他费用关闭
    handleCloseDia_otherFee() {
      this.isShowDialog_otherFee = false;
    },
    // 保存其他费项
    diaConfirmBtn_otherFee(array) {
      this.isShowDialog_otherFee = false;
      this.otherFeeReqs = array || [];
      let num = 0;
      this.otherFeeReqs.forEach((item) => {
        if (item.operationType !== "DEL") {
          num = this.$TOOLS.add(num, item.amount * 1).toFixed(2);
        }
      });
      this.addReqs.waybillList[this.specIndex1].otherFeeReqs =
        this.otherFeeReqs;
      this.addReqs.waybillList[this.specIndex1].otherFee = num;
    },
    // 其他费用部分
    // =========================================
    // 选择省(收货地址)
    changeProvince(e) {
      this.addReqs.carrierCity = "";
      this.carrierArea = "";
      this.cityArr = [];
      this.districtArr = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.carrierArea = "";
      this.districtArr = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 默认查省级
    getParentName(e) {
      this.$API
        .district({
          parentId: 1,
        })
        .then((res) => {
          this.provinceArr = res || [];
        });
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          this.cityArr = data;
        });
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          this.districtArr = data;
        });
    },
    // 提交
    submit: isImmediate.debounce(async function (isPosting) {
      let {
        startDeptId,
        outgoingReceiveMethodConfDictId,
        carrierId,
        carrierName,
        carrierDeptId,
        carrierDeptName,
        carrierPhone,
        contacts,
        carrierProvince,
        carrierCity,
        carrierAddress,
        settlementMethodConfDictId,
        outgoingNumber,
        remarks,
        waybillList,
        sendEmployeeId,
        sendEmployeeName,
        isAddCarrier,
        // dispatchDeptId,
        carrierUnitPrice,
        allCarrierWeigh,
        outgoingTime,
        isReceivedPayWithCarrier,
        allCarrierVolume,
        expectDeliveryTime,
        shouldInAmount,
        shouldOutAmount,
      } = this.addReqs;
      if (!outgoingReceiveMethodConfDictId) {
        this.$message.error(`请选择收货方式`);
        return false;
      }
      if (!outgoingNumber) {
        this.$message.error(`请输入承运商单号`);
        return false;
      }
      if (!carrierPhone) {
        this.$message.error(`请输入承运商电话`);
        return false;
      }
      if (!sendEmployeeId) {
        this.$message.error(`请选择发货人`);
        return false;
      }
      let params = {
        isPosting,
        startDeptId,
        outgoingReceiveMethodConfDictId,
        carrierId,
        carrierAttributeConfDictKey: this.carrierAttributeConfDictKey,
        carrierName,
        carrierDeptId,
        carrierDeptName,
        carrierPhone,
        contacts,
        carrierProvince,
        carrierCity,
        carrierArea: this.carrierArea,
        carrierAddress,
        settlementMethodConfDictId,
        outgoingNumber,
        remarks: remarks || "",
        sendEmployeeId,
        sendEmployeeName,
        // dispatchDeptId,
        isAddCarrier: this.isAddCarrier ? 1 : 0,
        carrierUnitPrice,
        allCarrierWeigh,
        outgoingTime,
        isReceivedPayWithCarrier,
        allCarrierVolume,
        expectDeliveryTime,
        shouldInAmount,
        shouldOutAmount,
      };
      //外发 提货方式 名称
      let curs2 = this.OUTTakeMethodList.filter(
        (item) => item.confDictId == outgoingReceiveMethodConfDictId
      );
      params.outgoingReceiveMethod = (curs2.length && curs2[0].val) || "";

      //外发 送货员
      let curs3 = this.employeeList.filter(
        (item) => item.documentId == sendEmployeeId
      );
      params.sendEmployeeName = (curs3.length && curs3[0].name) || "";

      // 运单信息
      let waybillReqs = [];
      waybillList.forEach((element) => {
        //外发 送货方式 名称
        element.sendMethodConfDictId = this.sendMethodConfDictId;
        let curs3 = this.OUTsendMethodList.filter(
          (item) => item.confDictId == element.sendMethodConfDictId
        );
        let wobjs = {
          waybillSplitId: element.waybillSplitId,
          sendFee: element.sendFee,
          outgoingSendMethodConfDictId: element.sendMethodConfDictId,
          outgoingSendMethod: (curs3.length && curs3[0].val) || "",
          // formulaBillingWeightId: element.formulaBillingWeightId,
          formulaBillingWeightId: this.formulaBillingWeightId,
          basicFreight: element.basicFreight,
          allOtherFee: element.otherFee,
          shareCarrierWeigh: element.shareCarrierWeigh,
          shareCarrierVolume: element.shareCarrierVolume,
          unitPrice: element.unitPrice,
          carrierUnitPrice: element.carrierUnitPrice,
          isReceivedPayWithCarrier: element.isReceivedPayWithCarrier,
          agentAmount: element.agentAmount,
          receivedAmount: element.receivedAmount,
          totalFreight: element.totalFreight,
          packageCout: element.packageCout,
          shouldInAmount: element.shouldInAmount,
          shouldOutAmount: element.shouldOutAmount,
        };
        if (element.otherFeeReqs && element.otherFeeReqs.length) {
          let arrls = [];
          element.otherFeeReqs.forEach((n) => {
            let objs = {
              amount: n.amount,
              itemCategoryId: n.itemCategoryId,
              itemCategoryName: n.itemCategoryName,
              itemServiceId: n.itemServiceId,
              itemServiceName: n.itemServiceName,
              remarks: n.remarks,
            };
            if (n.operationType && this.outgoingId) {
              objs.operationType = n.operationType;
            }
            arrls.push(objs);
          });
          wobjs.otherFeeReqs = arrls;
        }
        waybillReqs.push(wobjs);
      });
      params.waybillReqs = waybillReqs;
      params.contacts = this.addReqscontacts;
      this.submitLoading = true;
      try {
        if (this.waybillSplitIds.length) {
          await this.$API.outgoingaddOutgoingBillV5(params).then((res) => {
            if (res.data.status === "success") {
              window.localStorage.setItem(
                "tmsadmin_sendEmployeeName",
                params.sendEmployeeName
              );
              window.localStorage.setItem(
                "tmsadmin_sendEmployeeId",
                params.sendEmployeeId
              );
              this.$message.success(res.data.message || "操作成功");
              this.reset()
              this.$BaseIndex.closeCurrentTab("/OutgoingManage/OutgoingManage");
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        } else if (this.outgoingId) {
          params.outgoingId = this.outgoingId;
          await this.$API.outgoingupdateOutgoingBillV5(params).then((res) => {
            if (res.data.status === "success") {
              this.$message.success(res.data.message || "操作成功");
              this.reset()
              this.$BaseIndex.closeCurrentTab("/OutgoingManage/OutgoingManage");
            } else {
              this.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
        }
      } catch (error) {
        this.submitLoading = false;
      }
      this.submitLoading = false;
    }),
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 30px 10px;
}
</style>
